import type { GraphEdge, GraphMode, GraphSnapshot, TechnologyNode } from "./model";

export interface GraphFilter {
  query: string;
  layer: string;
  state: string;
  projectId: string;
  mode: GraphMode;
}

export function connectedNodeIds(selectedId: string, edges: GraphEdge[]): Set<string> {
  const connected = new Set<string>([selectedId]);
  for (const edge of edges) {
    if (edge.sourceId === selectedId) connected.add(edge.targetId);
    if (edge.targetId === selectedId) connected.add(edge.sourceId);
  }
  return connected;
}

export function filterNodes(snapshot: GraphSnapshot, filter: GraphFilter): TechnologyNode[] {
  const query = filter.query.trim().toLowerCase();
  const project = snapshot.projects.find((item) => item.id === filter.projectId);
  const projectNodeIds = new Set(project?.nodeIds ?? []);
  const actionNodeIds = new Set(
    snapshot.learningActions.filter((item) => item.status !== "done").map((item) => item.nodeId),
  );
  const evidenceNodeIds = new Set(snapshot.evidence.flatMap((item) => item.nodeIds));

  return snapshot.nodes.filter((node) => {
    if (filter.layer && node.layer !== filter.layer) return false;
    if (filter.state && node.capabilityState !== filter.state) return false;
    if (filter.projectId && !projectNodeIds.has(node.id)) return false;
    if (filter.mode === "LEARNING" && !actionNodeIds.has(node.id)) return false;
    if (filter.mode === "EVIDENCE" && !evidenceNodeIds.has(node.id)) return false;
    if (!query) return true;
    return [node.name, node.summary, node.layer, ...node.tags].join(" ").toLowerCase().includes(query);
  });
}

export function visibleEdges(nodes: TechnologyNode[], edges: GraphEdge[]): GraphEdge[] {
  const ids = new Set(nodes.map((node) => node.id));
  return edges.filter((edge) => ids.has(edge.sourceId) && ids.has(edge.targetId));
}
